import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-14 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-215">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="text-center mb-16" data-id="element-216">
        <h2 className="text-3xl md:text-4xl font-bold text-white font-heading mb-4 tracking-wider" data-id="element-217">
          EL PROBLEMA
        </h2>
        <div className="w-24 h-1 bg-gold-gradient mx-auto rounded-full" data-id="element-218" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      x: -20
    }} whileInView={{
      opacity: 1,
      x: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="bg-[#0f1d36] border-l-4 border-[#d4af37] rounded-r-2xl p-6 md:p-10 mb-12 shadow-lg relative overflow-hidden" data-id="element-219">
        <div className="absolute top-0 right-0 w-32 h-32 bg-[#d4af37] opacity-5 rounded-full blur-2xl translate-x-1/2 -translate-y-1/2" data-id="element-220" />

        <div className="space-y-4 text-[#e2e8f0] text-lg leading-relaxed font-light" data-id="element-221">
          <p data-id="element-222">Son las 11 de la noche.</p>
          <p data-id="element-223">Terminaste un día largo con tu paciente.</p>
          <p data-id="element-224">Estás agotado/a.</p>
          <p data-id="element-225">Y todavía te falta escribir el informe mensual.</p>
          <p data-id="element-226">Te sentás frente a la hoja en blanco.</p>
          <p data-id="element-227">No sabés por dónde empezar.</p>
          <p data-id="element-228">No sabés si lo que escribís suena profesional.</p>
          <p className="text-[#d4af37] font-medium" data-id="element-229">
            No sabés si esta vez te lo van a rechazar de nuevo.
          </p>
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: 0.2
    }} className="mb-12" data-id="element-230">
        <p className="text-xl text-white font-medium mb-6" data-id="element-231">
          Y cuando llega el rechazo, sabés exactamente lo que viene:
        </p>

        <ul className="space-y-4" data-id="element-232">
          {['El mes trabajado que no te pagan', 'La nota de reclamo que no sabés redactar', 'El psicólogo del equipo que te mira diferente', 'La familia que no entiende qué pasó', 'Tu credibilidad profesional en riesgo'].map((item, i) => <li key={i} className="flex items-start gap-3 text-[#e2e8f0] text-lg" data-id="element-233">
              <ArrowRight className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-234" />
              <span data-id="element-235">{item}</span>
            </li>)}
        </ul>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6,
      delay: 0.4
    }} className="text-center bg-[#0a1628] border border-[#1a2b4c] rounded-xl p-8" data-id="element-236">
        <p className="text-xl text-[#a0aec0] mb-4" data-id="element-237">
          ¿Cuánto te costó eso el año pasado?
        </p>
        <p className="text-2xl text-white font-bold mb-6" data-id="element-238">
          En tiempo. En dinero. En energía. En autoestima.
        </p>
        <p className="text-xl text-gold-gradient font-medium italic" data-id="element-239">
          Si sos honesto/a... sabés que demasiado.
        </p>
      </motion.div>
    </section>;
}